var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-bar',[_c('core-filter-bar-left',[_c('core-filter-summary',{attrs:{"title":_vm.title,"icon":"users","count":_vm.count,"noun":"user","maximum":_vm.maximum,"loading":_vm.loading}})],1),_c('core-filter-bar-right',[_c('core-filter-sort',{attrs:{"page":"users","filter":"users/sort"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }